"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSvg = _interopRequireDefault(require("react-svg"));
var _classnames = _interopRequireDefault(require("classnames"));
var _windowHelper = require("acq-utils/lib/Browser/window-helper");
var _getStaticHost = _interopRequireDefault(require("acq-utils/lib/Environment/get-static-host"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var svgFetcher = function svgFetcher(imageName, directory, props) {
  var _ref = props || {},
    _ref$wrapper = _ref.wrapper,
    wrapper = _ref$wrapper === void 0 ? 'span' : _ref$wrapper,
    _ref$fallback = _ref.fallback,
    fallback = _ref$fallback === void 0 ? null : _ref$fallback,
    _ref$svgClassName = _ref.svgClassName,
    svgClassName = _ref$svgClassName === void 0 ? '' : _ref$svgClassName,
    _ref$svgStyle = _ref.svgStyle,
    svgStyle = _ref$svgStyle === void 0 ? {} : _ref$svgStyle,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? null : _ref$onClick,
    _ref$onLoad = _ref.onLoad,
    onLoad = _ref$onLoad === void 0 ? undefined : _ref$onLoad,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden;
  var svgPath = "Internet/Acquisition/US_en/AppContent/OneSite/Data/SVG/".concat(directory, "/").concat(imageName, ".svg");
  return /*#__PURE__*/_react["default"].createElement(_reactSvg["default"], {
    src: "".concat((0, _getStaticHost["default"])((0, _windowHelper.getHostname)()), "/").concat(svgPath),
    wrapper: wrapper,
    fallback: fallback,
    svgClassName: svgClassName,
    svgStyle: svgStyle,
    className: (0, _classnames["default"])('svgIcon', className),
    onClick: onClick,
    onInjected: onLoad,
    "aria-hidden": ariaHidden
  });
};
var _default = exports["default"] = svgFetcher;
module.exports = exports.default;